import Validator from "validatorjs";
import ru from "validatorjs/src/lang/ru";
Validator.useLang('ru');

Validator.setMessages('ru', ru);

Validator.register('telephone', function (value) {
    return value.match(/^\+(?:[0-9] ?){6,14}[0-9]$/) !== null;
},'Введите корректный номер телефона в международном формате.');

export default Validator;

